export default "__VITE_ASSET__759e9402__"